module.exports = __webpack_public_path__ + "img/dots-loader.63b86538.svg";